module.exports = {
    styles:{
        // keep compatibility of old DOM
        'infw-yodlee-how-container1'             : 'container text-align-center',
        'infw-yodlee-how-container2'             : 'card-body pad-3-lr printable',
        'infw-yodlee-how-container3'             : 'pad-2 printable',
        'infw-yodlee-how-subtitle'               : 'body-1 margin-0-b text-xs-center printable',
        'infw-yodlee-how-answer'                 : 'infw-list-text-rws pad-1 heading-3 dls-core-blue-01',
        'infw-yodlee-how-section'                : '',
        'infw-list-text-rws'                     : 'pad-1 heading-3 dls-core-blue-01 printable',

        'infw-yodlee-tnc-confirm-container1'     : 'card-body',
        'infw-yodlee-tnc-confirm-container2'     : 'row',
        'infw-yodlee-tnc-confirm-container-chk'  : 'col-xs-1',
        'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc col-xs-11 pad-1-lr',
        'infw-yodlee-tnc-links'                  : 'card-body pad-3-lr text-align-center',

        'infw-checkbox'                          : '',
        'dummy':''
    },

    labels:{
        en_US: {
            "widget.message": "We need additional information from you.",
            "yodlee.home.how": "<div>How It Works</div><div class=\"pad-1-t heading-3 dls-core-blue-01\" style=\"font-size:1.2em;\">We work with a third party provider to get an overview of your recent finances without having to pull your credit report again.</div>"
        },
        es_US: {

        }
    }
};



// WEBPACK FOOTER //
// ./application/src/themes/dxp_acq.js